module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2032928750/src/~/core-js/library/modules/_redefine.js
// module id = L1xW
// module chunks = 6